import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

import CustomScrollbar from 'web/components/common/CustomScrollbar';
import PolicyContent from 'web/routes/info/PolicyContent';
import TermContent from 'web/routes/info/TermContent';

@withRouter
class TermAndPolicy extends Component {
  state = {
    fontSize: '14px',
  };
  componentDidMount() {
    const parsed = queryString.parse(this.props.location.search);
    if (parsed.fontsize && parsed.fontsize !== '14px') {
      this.setState({
        fontSize: parsed.fontsize,
      });
    }
  }

  render() {
    return (
      <CustomScrollbar>
        <TermContent fontSize={this.state.fontSize} />
        <PolicyContent fontSize={this.state.fontSize} />
      </CustomScrollbar>
    );
  }
}

export default TermAndPolicy;
